module.exports = __webpack_public_path__ + "static/media/testing-locations.bfddd579.svg";